import type { IKpiRepository } from '../repositories/IKpiRepository.js';

interface Deps { kpiRepository: IKpiRepository; }
export function createDeleteKpiUseCase({ kpiRepository }: Deps) {
  return async function deleteKpi(id: string): Promise<void> {
    return kpiRepository.delete(id);
  };
}
